import { put, takeLatest } from "redux-saga/effects";
import { getCRMRewardDetailApi } from "store/api/HomeApi";
import { GET_CRM_REWARD_DETAIL_ACTION } from "../../actions/HomePageAction/actionTypes";

import * as homePageAction from "../../actions/HomePageAction";
import * as globalAction from "../../actions/GlobalAction";

function* errorMessage(message) {
	const alert = { isError: true, message: message, isOpenAlert: true };
	yield put(globalAction.setAlertMessage(alert));
}

function* getCRMRewardDetail() {
	const res = yield getCRMRewardDetailApi();
	try {
		if (res?.code === 0) {
			yield put(
				homePageAction.setCRMRewardDetailAction(res?.data?.detail)
			);
		} else {
			yield errorMessage(res?.message);
		}
	} catch (e) {
		console.log(e);
	}
}

function* getCRMRewardDetailSaga() {
	yield takeLatest(GET_CRM_REWARD_DETAIL_ACTION, getCRMRewardDetail);
}

export default getCRMRewardDetailSaga;
